import React, { useMemo } from 'react';

import { TiptapRichTextEditor } from 'components/DesignSystems/New/TiptapRichTextEditor';
import {
  useSitrepSectionImages,
  type SitrepSectionType,
} from 'components/DisasterGPT/hooks/useSitrepsV2';

type ReadOnlyReportsSectionDisplayProps = {
  section: SitrepSectionType;
};

const ReadOnlyReportsSectionDisplay: React.FC<
  ReadOnlyReportsSectionDisplayProps
> = ({ section }) => {
  const latestVersion = useMemo(
    () => section.section_versions?.[0],
    [section.section_versions]
  );

  const { data: sitrepImages } = useSitrepSectionImages(section.id);

  const sectionText = useMemo(
    () => latestVersion?.sitrep_section_text || '',
    [latestVersion?.sitrep_section_text]
  );

  return (
    <div className="reports-section">
      <div>
        {sectionText && (
          <TiptapRichTextEditor
            value={sectionText}
            readOnly
            showToolbar={false}
            minHeight="2rem"
            className="reports-section__html-content"
            normalizeMarkdown
            imageLibrary={sitrepImages || []}
          />
        )}
      </div>
    </div>
  );
};

export default ReadOnlyReportsSectionDisplay;
